const blogPostCategories = () => {
  return '/blog-post-categories'
}

export default blogPostCategories